import React, { useState } from 'react';
import { useHistory } from 'react-router';

// MUI
import { Box, Container } from '@mui/system';
import { Typography, Grid  } from '@mui/material';

// blocks
import InputField from '../../../../../components/forms/InputField/InputField.component';

// block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup';

// utils
import { cleanJobDaysData, calculateManHours, filterDays } from './JobDetailDays.collection.utils';
import { dateComparator } from '../../../../../shared/sorting/dates'

const jobDetailDaysColumnConfigs = [
    { 
        name: "date", 
        title: "Date", 
        objectFieldsToDisplay: ["date"],
        objectFieldsDelimeter: "", 
        useNestedObject: false ,
        type: 'date',
        sortComparator: dateComparator
    },
    { 
        name: "foreman", 
        title: "Foreman", 
        objectFieldsToDisplay: ["foreman"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "crewSize", 
        title: "Crew Size", 
        objectFieldsToDisplay: ["crewSize"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    { 
        name: "timeTicketStatus", 
        title: "Time Ticket Status", 
        objectFieldsToDisplay: ["ticketStatus"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
];
const JobDetailDays = ({data = { job: { jobDays: [] } }, loading, error}) => {
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const history = useHistory()
    const handleRowClick = (rowData) => {
        history.push(`/schedule/jobDay/${rowData.id}`)
    }
    const [sortModel, setSortModel] = useState([{ field: "date", sort: "desc" }])

    const cleanedData = filterDays(cleanJobDaysData(data.job.jobDays), startDate, endDate)

    const totalManHours = calculateManHours(cleanedData) 

    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Grid container spacing={2} disableGutters alignItems={'center'} >
            <Grid item xs={2}><Typography variant='h4'>Job Days</Typography></Grid>
            <Grid item xs={2}><Typography>Total Man Hours: {totalManHours.toFixed(2)}</Typography></Grid>
            <Grid item container spacing={2} xs={8} justifyContent='flex-end' alignItems={'center'}>
                <Grid item><InputField 
                    id="date"
                    placeholder="Start Date"
                    type="date"
                    size='small'
                    onChange={value => setStartDate(value)}
                    value={startDate}
                /></Grid>
                <Grid item><InputField 
                    placeholder="End Date"
                    type="date"
                    size='small'
                    onChange={value => setEndDate(value)}
                    value={endDate}
                /></Grid>
            </Grid>
        </Grid>
        <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
            <BaseTable
                rawData={cleanedData} 
                columnConfigs={jobDetailDaysColumnConfigs} 
                loading={false}  
                onRowClick={handleRowClick}
                sortModel={sortModel}
                onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            />
        </Box>
    </Container>)
}

export default JobDetailDays;